import { COLOR_WHITE } from "#constants/Styles"
import { TarjetaProvider, UseTarjetaContext } from "#training/contexts/contextsTarjeta"
import { Box, Link, Stack, Tooltip, Typography } from "@mui/material"
import Card from "@mui/material/Card"
import CardContent from "@mui/material/CardContent"
import TextoTypography from "Components/Capacitaciones/componentes/TextoTypography"
import { COLOR_TARJETA, MESES } from "Components/Capacitaciones/constants_capacitaciones"
import "react-toastify/dist/ReactToastify.css"
import TarjetaButtons from "./TarjetaButtons"
import TarjetaDialog from "./TarjetaDialog"
// import { Link } from "react-router-dom"
import { useMemo } from "react"

export default function Tarjeta({ curso, showColaborador = false, setOpenPdf }) {
	return (
		<TarjetaProvider curso={curso} showColaborador={showColaborador}>
			<Card
				key={`Card${curso.id}`}
				sx={{
					minWidth: "300px",
					maxWidth: "550px",
					height: "100%",
					m: 0.5,
					borderRadius: 4,
					boxShadow: 10,
				}}
			>
				<Title />
				<Contenido />
			</Card>
			<TarjetaDialog />
		</TarjetaProvider>
	)
}

const Title = () => {
	const {
		curso: { category, mes, status },
	} = UseTarjetaContext()

	return (
		<Box
			sx={{
				// padding: "10px",
				paddingLeft: "15px",
				backgroundColor: COLOR_TARJETA(status),
			}}
		>
			<Stack
				// direction="row"
				alignItems="center"
				justifyContent={"space-between"}
				spacing={2}
				direction={{ xs: "column", sm: "row" }}
			>
				<div>
					<Stack
						direction={"column"}
						alignItems={{ xs: "center", sm: "flex-start" }}
						spacing={0}
					>
						<Typography
							variant="h6"
							textAlign={"left"}
							sx={{
								fontWeight: "bold",
								color: COLOR_WHITE,
							}}
						>
							{MESES[mes].label}
						</Typography>
						<Typography
							variant="h8"
							sx={{
								fontWeight: "bold",
								color: COLOR_WHITE,
							}}
						>
							{category}
						</Typography>
					</Stack>
				</div>
				<TarjetaButtons />
			</Stack>
		</Box>
	)
}

const Contenido = () => {
	const {
		showColaborador,
		curso: {
			colaborador,
			curso: { plataforma, nombre, link },
			validado,
		},
	} = UseTarjetaContext()

	const TextName = useMemo(() => {
		if (link)
			return (
				<Link target="_blank" href={link} variant="h5">
					<Typography
						variant="h5"
						component="div"
						sx={{
							mb: 1.5,
							fontWeight: "bold",
							whiteSpace: "nowrap",
							overflow: "hidden",
							textOverflow: "ellipsis",
						}}
					>
						{nombre}
					</Typography>
				</Link>
			)
		else
			return (
				<Typography
					variant="h5"
					component="div"
					sx={{
						mb: 1.5,
						fontWeight: "bold",
						whiteSpace: "nowrap",
						overflow: "hidden",
						textOverflow: "ellipsis",
					}}
				>
					{nombre}
				</Typography>
			)
	}, [link, nombre])

	return (
		<CardContent sx={{ paddingLeft: "15px" }}>
			<Stack padding={0}>
				<div>
					<Tooltip title={nombre} placement="top">
						{TextName}
					</Tooltip>
					{showColaborador && (
						<Typography
							variant="h6"
							component="div"
							sx={{ mb: 1.0, fontWeight: "bold" }}
						>
							{colaborador}
						</Typography>
					)}
					<TextoTypography Texto={`Plataforma:${plataforma} `} />
					{validado && <TextoTypography Texto={`Aprobado el: ${validado}`} />}
				</div>
				{/* <TarjetaPdf /> */}
			</Stack>
		</CardContent>
	)
}
